import { QBR_TRANSLATIONS_NAMESPACE } from '../../../../../translations'

export const QBR_EXPORT_TRANSLATIONS_NAMESPACE = `${QBR_TRANSLATIONS_NAMESPACE}--qbr-export`

export const TRANSLATION_KEYS = {
  qbrExport: {
    qbrLastChangesMessage: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--clarification-message--last-changes-since`,
    // You can select QBR slides to download in PPTX format
    pleaseGenerateQbr: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--clarification-message--please-generate-qbr`,

    slides: {
      financial: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--qbr-slide--financial`,
    },

    selectEltSlidesMessage: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--select-elt-slides--title`,
    eltSlidesDisclaimer: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--elt-slides-disclaimer`,
    createNewEltMessage: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--create-new-elt`,
    eltSlides: {
      financial: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--elt-slide--financial`,
    },

    generateQbrButton: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--action-buttons--generate-qbr-button-label`,
    downloadQbrButton: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--action-buttons--download-qbr-button-label`,

    generatePptxReportSuccess: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--response-message--generate-pptx-report-success`,
    somethingWentWrong: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--response-message--something-went-wrong`,
  },

  qbrAttachments: {
    dnd: {
      dragAndDrop: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--dnd--drag-and-drop-label`,
      ctrlV: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--dnd--ctrl-v`,
      or: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--dnd--or`,
      browseFiles: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--dnd--browse-files`,
    },
    attachmentsColumns: {
      fileName: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--attachments-columns--filename-label`,
      uploadDate: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--attachments-columns--upload-date-label`,
      creator: `${QBR_EXPORT_TRANSLATIONS_NAMESPACE}--attachments-columns--creator-label`,
    },
  },
}
